import React, { Component } from "react";
import { Table, TableBody } from "material-ui";
import TotalRow from "./TotalRow";
import TaxDiscountRow from "./TaxDiscountRow";
import TotalBillRow from "./TotalBillRow";

class CartFooter extends Component {
  state = {};

  render() {
    const { cartArray, summary } = this.props;

    if (summary.noOfItems === 0) {
      return null;
    }

    const totalQtyText = `${summary.noOfItems} (${summary.noOfInividualItems})`;
    const totalPrice = summary.total;
    const { netTotal } = summary;

    return (
      <div
        style={{
          marginTop: 18,
          marginLeft: 10,
          marginRight: 10,
          marginBottom: 10,
          borderRadius: 16,
          background: "#f8fbfa",
          border: "1px solid #e4eeea",
          overflow: "hidden",
          boxShadow: "0 5px 18px rgba(24, 61, 50, 0.05)"
        }}
      >
        <div
          style={{
            padding: "13px 16px",
            background: "#ffffff",
            borderBottom: "1px solid #e8efec",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          <div
            style={{
              fontSize: 11,
              fontWeight: 800,
              color: "#19352d",
              letterSpacing: "0.6px",
              textTransform: "uppercase"
            }}
          >
            Order Summary
          </div>

          <div
            style={{
              fontSize: 10,
              fontWeight: 700,
              color: "#16845b",
              background: "#edf8f3",
              padding: "5px 8px",
              borderRadius: 8
            }}
          >
            {summary.noOfItems} items
          </div>
        </div>

        <Table
          style={{
            marginTop: 0,
            background: "transparent"
          }}
        >
          <TableBody>
            <TotalRow
              totalQtyText={totalQtyText}
              totalPrice={totalPrice}
            />

            <TaxDiscountRow
              cartArray={cartArray}
              summary={summary}
            />

            <TotalBillRow
              netTotal={netTotal}
            />
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default CartFooter;
